import script from "./RichMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./RichMenu.vue?vue&type=script&lang=ts&setup=true"

import "./RichMenu.vue?vue&type=style&index=0&id=a0695a62&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0695a62"]])

export default __exports__